import { render, staticRenderFns } from "./ProyectosView.vue?vue&type=template&id=7cf4f9a4&scoped=true"
import script from "./ProyectosView.vue?vue&type=script&lang=js"
export * from "./ProyectosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf4f9a4",
  null
  
)

export default component.exports